import { render, staticRenderFns } from "./storeIssue.vue?vue&type=template&id=2f9d1564&scoped=true"
import script from "./storeIssue.vue?vue&type=script&lang=js"
export * from "./storeIssue.vue?vue&type=script&lang=js"
import style0 from "./storeIssue.vue?vue&type=style&index=0&id=2f9d1564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d1564",
  null
  
)

export default component.exports